import React from 'react'

import { CommandItem } from '@/shared/components/ui/command'
import { cn } from '@/shared/lib/utils'

import { useMutationObserver } from '../lib/useMutationObserver'

export function CommandMenuItem({
	children,
	className,
	onHighlight,
	...props
}: React.ComponentProps<typeof CommandItem> & {
	onHighlight?: () => void
	'data-selected'?: string
	'aria-selected'?: string
}) {
	const ref = React.useRef<HTMLDivElement>(null)

	useMutationObserver(ref, (mutations) => {
		mutations.forEach((mutation) => {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'aria-selected' &&
				ref.current?.getAttribute('aria-selected') === 'true'
			) {
				onHighlight?.()
			}
		})
	})

	return (
		<CommandItem
			ref={ref}
			className={cn(
				'h-9 rounded-md border border-transparent !px-3 font-medium data-[selected=true]:border-input data-[selected=true]:bg-input/50',
				className
			)}
			{...props}
		>
			{children}
		</CommandItem>
	)
}
